<rl-form-table-row>
	<ng-template rlFormTableLabel>Record Type</ng-template>
	<ng-template rlFormTableControl>
		<rl-dropdown-single [(ngModel)]="selectedType" (ngModelChange)="updateParams()" [options]="options"
			[showEmptyOption]="true" [dataLabel]="'DefaultSelect'">
		</rl-dropdown-single>
	</ng-template>
</rl-form-table-row>